
import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(null);
  const [loading, setLoading] = useState(true);

  // nivel/role/permissões atuais vêm do banco a cada carga: o usuario salvo no login
  // pode estar velho (admin mudou o nível ou os módulos liberados). Falha de rede não
  // derruba a sessão — segue com o que estava salvo (o backend barra do mesmo jeito).
  const atualizarPermissoes = async (u) => {
    try {
      const { data } = await api.get('/usuarios/permissoes/me');
      if (!data?.nivel) return u;
      const novo = { ...u, nivel: data.nivel, role: data.role, permissoes: data.permissoes, assinatura: data.assinatura || null };
      localStorage.setItem('usuario', JSON.stringify(novo));
      return novo;
    } catch { return u; }
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('usuario');
    if (token && user) {
      const salvo = JSON.parse(user);
      setUsuario(salvo);
      atualizarPermissoes(salvo).then(u => { setUsuario(u); setLoading(false); });
      return;
    }
    setLoading(false);
  }, []);

  const login = async (email, senha) => {
    const res = await api.post('/auth/login', { email, senha });
    localStorage.removeItem('impersonacao'); // login normal nunca é impersonação
    localStorage.setItem('token', res.data.token);
    localStorage.setItem('usuario', JSON.stringify(res.data.usuario));
    const u = await atualizarPermissoes(res.data.usuario);
    setUsuario(u);
    return u;
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    localStorage.removeItem('impersonacao');
    setUsuario(null);
  };

  return (
    <AuthContext.Provider value={{ usuario, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
